module.exports = __webpack_public_path__ + "img/RainorView.2817d70d.png";